var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    {
      staticClass: "article",
      class: {
        headerIsDisabled: _vm.post["acf"]["config_disable_header"],
        teaserIsDisabled: _vm.post["acf"]["config_disable_teaser"],
        featuresIsDisabled: _vm.post["acf"]["config_disable_features"],
        isEmpty: _vm.isEmpty
      },
      attrs: { "data-content-class": this.post["acf"]["content_class"] }
    },
    [
      _vm.isLoaded
        ? _c(
            "div",
            { staticClass: "article-inner" },
            [
              _vm.post["acf"]["config_disable_header"] !== true
                ? [
                    _vm.post["acf"]["teaser_video_youtube_id"]
                      ? [
                          _vm.isRendered
                            ? _c(
                                "div",
                                {
                                  staticClass: "article-hero-video",
                                  attrs: {
                                    "data-log":
                                      _vm.post["acf"]["teaser_video_youtube_id"]
                                  }
                                },
                                [
                                  _c("div", { staticClass: "youtube-wrap" }, [
                                    _c("iframe", {
                                      attrs: {
                                        width: "640",
                                        height: "360",
                                        frameborder: "0",
                                        src:
                                          "https://www.youtube.com/embed/" +
                                          _vm.post["acf"][
                                            "teaser_video_youtube_id"
                                          ] +
                                          "?hl=de&modestbranding=1&rel=0&showinfo=0"
                                      }
                                    })
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      : [
                          _vm.post["acf"]["teaser_image_3840_1536"]
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "article-hero-container" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "article-hero",
                                        style: {
                                          backgroundImage:
                                            "url(" + _vm.headerImage() + ")"
                                        }
                                      },
                                      [
                                        _c("div", { staticClass: "overlay" }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "article-hero-caption",
                                            class: {
                                              "article-hero-caption-right":
                                                _vm.post["acf"][
                                                  "teaser_headline_position"
                                                ] === "right"
                                            }
                                          },
                                          [
                                            _vm.post["acf"]["teaser_headline"]
                                              ? _c(
                                                  _vm.post["acf"][
                                                    "teaser_headline_tag"
                                                  ] || "p",
                                                  {
                                                    tag: "component",
                                                    staticClass:
                                                      "content-headline",
                                                    class: {
                                                      "content-headline-black":
                                                        _vm.post["acf"][
                                                          "teaser_headline_color"
                                                        ] === "black",
                                                      "content-headline-pink":
                                                        _vm.post["acf"][
                                                          "teaser_headline_color"
                                                        ] === "red",
                                                      "content-headline-white":
                                                        _vm.post["acf"][
                                                          "teaser_headline_color"
                                                        ] === "white",
                                                      "content-headline-none":
                                                        _vm.post["acf"][
                                                          "teaser_headline_color"
                                                        ] === "none"
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.post["acf"][
                                                          "teaser_headline"
                                                        ]
                                                      )
                                                    }
                                                  }
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.post["acf"][
                                      "teaser_image_copyright_text"
                                    ]
                                      ? _c("div", {
                                          staticClass: "image-copyright-text",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              "&copy; " +
                                                _vm.post["acf"][
                                                  "teaser_image_copyright_text"
                                                ]
                                            )
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ]
                            : _vm._e()
                        ]
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "article-content",
                  class: { isEmpty: _vm.isEmpty }
                },
                [
                  _vm._l(_vm.post["acf"]["content_composer"], function(
                    content,
                    contentIndex
                  ) {
                    return [
                      content["acf_fc_layout"] ===
                      "content_composer_headline_h1"
                        ? _c("h1", { staticClass: "content-headline" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(content["content_headline_h1"]) +
                                "\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      content["acf_fc_layout"] === "content_composer_subline_h2"
                        ? _c("h2", { staticClass: "content-subline" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(content["content_subline_h2"]) +
                                "\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      content["acf_fc_layout"] === "content_composer_subline_h3"
                        ? _c("h3", { staticClass: "content-subline" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(content["content_subline_h3"]) +
                                "\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      content["acf_fc_layout"] === "content_composer_copy_body"
                        ? _c("div", {
                            staticClass: "content-copy-body",
                            class: {
                              isFirstOfLayout:
                                _vm.wpApi.indexOfFirstACFFlexibleContentLayout(
                                  _vm.post["acf"]["content_composer"],
                                  "content_composer_copy_body"
                                ) === contentIndex,
                              isLastOfLayout:
                                _vm.wpApi.indexOfLastACFFlexibleContentLayout(
                                  _vm.post["acf"]["content_composer"],
                                  "content_composer_copy_body"
                                ) === contentIndex
                            },
                            domProps: {
                              innerHTML: _vm._s(content["content_copy_body"])
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      content["acf_fc_layout"] === "content_composer_footnotes"
                        ? _c("div", {
                            staticClass: "content-footnotes",
                            domProps: {
                              innerHTML: _vm._s(content["content_footnotes"])
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      content["acf_fc_layout"] ===
                      "content_composer_featured_person"
                        ? [
                            _c(
                              "div",
                              { staticClass: "article-featured-person" },
                              [
                                _c("div", {
                                  staticClass: "content-featured-person-image",
                                  style: {
                                    backgroundImage:
                                      "url(" +
                                      content[
                                        "content_featured_person_image_512_512"
                                      ] +
                                      ")"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "article-featured-person-details"
                                  },
                                  [
                                    _c(
                                      "h4",
                                      {
                                        staticClass:
                                          "content-featured-person-name"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              content[
                                                "content_featured_person_name"
                                              ]
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass:
                                        "content-featured-person-info",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          content[
                                            "content_featured_person_info"
                                          ]
                                        )
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      content["acf_fc_layout"] === "content_composer_address"
                        ? _c("address", {
                            staticClass: "article-address",
                            domProps: {
                              innerHTML: _vm._s(content["content_address"])
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      content["acf_fc_layout"] === "content_composer_video"
                        ? [
                            _vm.isRendered
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "article-video",
                                    attrs: {
                                      "data-log":
                                        content["content_video_youtube_id"]
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "youtube-wrap" }, [
                                      _c("iframe", {
                                        staticClass: "optanon-category-C0004",
                                        attrs: {
                                          width: "640",
                                          height: "360",
                                          frameborder: "0",
                                          src:
                                            "https://www.youtube.com/embed/" +
                                            content[
                                              "content_video_youtube_id"
                                            ] +
                                            "?hl=de&modestbranding=1&rel=0&showinfo=0",
                                          "data-src":
                                            "https://www.youtube.com/embed/" +
                                            content[
                                              "content_video_youtube_id"
                                            ] +
                                            "?hl=de&modestbranding=1&rel=0&showinfo=0"
                                        }
                                      })
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            content["content_video_title"]
                              ? _c(
                                  "h1",
                                  { staticClass: "content-video-title" },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(content["content_video_title"]) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            content["content_video_summary"]
                              ? _c("div", {
                                  staticClass: "content-video-summary",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      content["content_video_summary"]
                                    )
                                  }
                                })
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      content["acf_fc_layout"] === "content_composer_new_video"
                        ? [
                            _c("content-new-video", {
                              attrs: {
                                title: content["content_new_video_title"],
                                description:
                                  content["content_new_video_description"],
                                file: content["content_new_video_file"],
                                thumbnail:
                                  content["content_new_thumbnail_file"],
                                layout: content["content_new_video_layout"]
                              }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      content["acf_fc_layout"] === "content_composer_image" &&
                      content["content_image_1440_1080"]
                        ? _c(
                            "div",
                            { staticClass: "content-image-container" },
                            [
                              _c("div", { staticClass: "content-image" }, [
                                _c("img", {
                                  attrs: {
                                    alt: content["content_image_alt_text"],
                                    src: content["content_image_1440_1080"]
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              content["content_image_copyright_text"]
                                ? _c("div", {
                                    staticClass: "image-copyright-text",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        "&copy; " +
                                          content[
                                            "content_image_copyright_text"
                                          ]
                                      )
                                    }
                                  })
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      content["acf_fc_layout"] === "content_composer_highlight"
                        ? _c("div", { staticClass: "content-highlight" }, [
                            content["content_highlight_copy_body"]
                              ? _c("div", {
                                  staticClass: "content-highlight-copy-body",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      content["content_highlight_copy_body"]
                                    )
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            content["content_highlight_image_1440_1080"]
                              ? _c(
                                  "div",
                                  { staticClass: "content-highlight-image" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        alt:
                                          content[
                                            "content_highlight_image_alt_text"
                                          ],
                                        src:
                                          content[
                                            "content_highlight_image_1440_1080"
                                          ]
                                      }
                                    }),
                                    _vm._v(" "),
                                    content[
                                      "content_highlight_image_copyright_text"
                                    ]
                                      ? _c("div", {
                                          staticClass: "image-copyright-text",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              "&copy; " +
                                                content[
                                                  "content_highlight_image_copyright_text"
                                                ]
                                            )
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      content["acf_fc_layout"] === "content_composer_list" &&
                      content["content_list_type"] === "accordion"
                        ? [
                            !content.hasOwnProperty(
                              "content_list_collapsible"
                            ) || content["content_list_collapsible"] !== true
                              ? _c("article-accordion", {
                                  attrs: {
                                    "article-accordion-data": content,
                                    "article-accordion-id": String(contentIndex)
                                  }
                                })
                              : content["content_list_collapsible"] === true
                              ? _c("article-accordion-collapsible", {
                                  attrs: {
                                    "article-accordion-data": content,
                                    "article-accordion-id": String(contentIndex)
                                  }
                                })
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      content["acf_fc_layout"] ===
                        "content_composer_component" &&
                      content["content_component"] ===
                        "content-hiv-info-graphic"
                        ? [
                            _c(
                              "div",
                              { staticClass: "article-component" },
                              [_c("content-hiv-info-graphic")],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      content["acf_fc_layout"] === "content_composer_teaser"
                        ? _c(
                            "div",
                            { staticClass: "content-teaser row mx-auto my-4" },
                            [
                              _c(
                                "div",
                                {
                                  class: [
                                    "col",
                                    "col-12",
                                    "col-lg-6",
                                    "px-0",
                                    "content-teaser-left",
                                    "bg-" +
                                      content["content_teaser_background_color"]
                                  ]
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "content-teaser-overlay-left h-100 position-absolute"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "content-teaser-left-inner"
                                    },
                                    [
                                      content["content_teaser_headline"]
                                        ? _c("div", {
                                            staticClass:
                                              "content-teaser-headline text-white font-weight-bold",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                content[
                                                  "content_teaser_headline"
                                                ]
                                              )
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      content["content_teaser_subheadline"]
                                        ? _c("div", {
                                            staticClass:
                                              "content-teaser-subheadline text-white",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                content[
                                                  "content_teaser_subheadline"
                                                ]
                                              )
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      content["content_teaser_text"]
                                        ? _c("div", {
                                            staticClass:
                                              "content-teaser-text text-white mb-1 mb-lg-4",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                content["content_teaser_text"]
                                              )
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      content["content_teaser_cta"][
                                        "content_teaser_cta_link"
                                      ]
                                        ? _c("a", {
                                            class: [
                                              "btn",
                                              "content-teaser-cta",
                                              "ani-btn-hover-scale-bounce",
                                              content[
                                                "content_teaser_background_color"
                                              ] === "black"
                                                ? "btn-pink-white"
                                                : "btn-black-white"
                                            ],
                                            attrs: {
                                              href:
                                                content["content_teaser_cta"][
                                                  "content_teaser_cta_link"
                                                ]
                                            },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                content["content_teaser_cta"][
                                                  "content_teaser_cta_label"
                                                ]
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              content["content_teaser_image"]
                                ? _c(
                                    "div",
                                    { staticClass: "col col-12 col-lg-6 px-0" },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "content-teaser-image h-100 position-absolute",
                                        style: {
                                          backgroundImage:
                                            "url(" +
                                            content["content_teaser_image"][
                                              "url"
                                            ] +
                                            ")"
                                        },
                                        attrs: { role: "img" }
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticClass: "w-100 h-auto invisible",
                                        attrs: {
                                          alt:
                                            content["content_teaser_image"][
                                              "alt"
                                            ],
                                          src:
                                            content["content_teaser_image"][
                                              "url"
                                            ]
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.shouldShowPdfModule
                ? _c("div", { staticClass: "content-highlight" }, [
                    _c("div", { staticClass: "content-highlight-copy-body" }, [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.pdfModule.pdf_module_text)
                        }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.$route.params && this.$route.params["permalink"]
                ? _c("sticky-questionnaire", {
                    attrs: { articleId: this.$route.params["permalink"] }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showRatingOption
                ? _c(
                    "div",
                    { staticClass: "rating-section" },
                    [
                      _c("Rating", { attrs: { "pid-param": _vm.post["id"] } }),
                      _vm._v(" "),
                      _c("nav", { staticClass: "article-social" }, [
                        _c("ul", { staticClass: "social-icon-listing" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("li", { staticClass: "social-icon-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "article-social-ic-on",
                                attrs: { href: _vm.facebookUrl },
                                on: {
                                  click: function($event) {
                                    return _vm.shareOnFacebook($event)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/img/ic_facebook.svg",
                                    alt: "Facebook"
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "social-icon-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "article-social-ic-on",
                                attrs: {
                                  href:
                                    "mailto:?subject=" +
                                    _vm.post["title"]["rendered"] +
                                    "&body=" +
                                    _vm.post["link"]
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/img/ic_mailto.svg",
                                    alt: "MailTo"
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "social-icon-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "article-social-ic-on",
                                attrs: {
                                  href:
                                    "WhatsApp://send?text=" +
                                    encodeURI(_vm.post["title"]["rendered"]) +
                                    "-" +
                                    encodeURIComponent(_vm.post["link"])
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: "/img/ic_whatsapp.svg",
                                    alt: "Whatsapp"
                                  }
                                })
                              ]
                            )
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.post["acf"]["referenzen_list"] !== undefined &&
              _vm.post["acf"]["referenzen_list"].length > 0
                ? _c(
                    "div",
                    { staticClass: "referenzen-container" },
                    [
                      _c("div", { staticClass: "h2 heading" }, [
                        _vm._v("Referenzen")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.post["acf"]["referenzen_list"], function(
                        referenzen,
                        referenzenIndex
                      ) {
                        return [
                          referenzen["text"] || referenzen["ref"]
                            ? _c("div", { staticClass: "referenzen" }, [
                                _c("sup", {
                                  staticClass: "ref-index",
                                  domProps: {
                                    innerHTML: _vm._s(referenzen["index"])
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "ref-text d-inline",
                                  domProps: {
                                    innerHTML: _vm._s(referenzen["text"])
                                  }
                                }),
                                _vm._v(" "),
                                referenzen["ref"]
                                  ? _c("div", {
                                      staticClass: "ref-url d-inline",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          "<img width='20px' src='/img/right-arrow_e73e51.png'>" +
                                            _vm.stringToLink(referenzen["ref"])
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoaded && _vm.post["acf"]["config_disable_features"] !== true
        ? _c("features-wide", {
            attrs: {
              "features-exclude-post-permalinks": [_vm.$route.params.permalink],
              "features-filter-params": _vm.featuresFilterParams,
              "features-heading": "DAS KÖNNTE Dich AUCH INTERESSIEREN",
              "features-id": "articleFeatures"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "social-icon-heading" }, [
      _c("img", { attrs: { src: "/img/ic_share_000000.svg", alt: "Share" } }),
      _vm._v("Teilen:")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ec6664b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ec6664b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/Article.vue
// module id = 593
// module chunks = 0